import { useState } from 'react';
import { notifyPhoneCall, notifyPhoneShow } from '../../utils/phoneShow';

// The support line the header reveals — the same number the Organization JSON-LD
// and the no-JS shell in index.html publish.
const PHONE_DISPLAY = '06 30 626 6000';
const PHONE_TEL = '+36306266000';
const OPENING_HOURS = 'Minden nap 8-24 óráig';

type Props = {
	/** Modifier class for the placement, e.g. `phonebtn--footer`. */
	className?: string;
};

const PhoneIcon = () => (
	<svg className="phonebtn__icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
		<path d="M6.6 10.8a15.1 15.1 0 0 0 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.2.4 2.4.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1A17 17 0 0 1 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.4 0 .8-.2 1l-2.3 2.2Z" />
	</svg>
);

/**
 * "Telefonos ügyfélszolgálat" button. The first click reveals the number — the
 * button's own text is REPLACED by it — and reports the reveal to Analytics + the
 * internal visitor-session tracking (see notifyPhoneShow). Once revealed the whole
 * control is a `tel:` link, so the next click places the call: the dialer on mobile,
 * the registered handler (FaceTime/Skype/Teams/a softphone) on desktop.
 *
 * The opening hours sit under the button and are always on screen — before AND
 * after the reveal.
 */
export default function PhoneSupport({ className = '' }: Props) {
	const [revealed, setRevealed] = useState(false);
	const cls = `phonebtn ${className}`.trim();

	if (revealed) {
		return (
			<a
				href={`tel:${PHONE_TEL}`}
				className={`${cls} phonebtn--revealed`}
				aria-label={`Hívás: ${PHONE_DISPLAY}`}
				onClick={() => notifyPhoneCall()}
			>
				<span className="phonebtn__btn">
					<PhoneIcon />
					<span className="phonebtn__text">{PHONE_DISPLAY}</span>
				</span>
				<span className="phonebtn__hours">{OPENING_HOURS}</span>
			</a>
		);
	}

	return (
		<button
			type="button"
			className={cls}
			onClick={() => {
				setRevealed(true);
				notifyPhoneShow();
			}}
		>
			<span className="phonebtn__btn">
				<PhoneIcon />
				<span className="phonebtn__text">Telefonos ügyfélszolgálat</span>
			</span>
			<span className="phonebtn__hours">{OPENING_HOURS}</span>
		</button>
	);
}
